import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import { ErrorText } from '../../../components';
import {  validatePhone } from '../../../utils/validate';


const MAX_VALUE = 100000000;
const FORM_KEYS = [
    'name',
    'phoneNumber'
]

export default class FranchiseModal extends Component {
    constructor() {
        super()
        this.state = this.getInitState();
    }

    getInitState = () => ({
        form: {
            name: '',
            phoneNumber: ''
        },
        errors: {}
    });

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.setEditMode();
        }
    }

    setEditMode = () => {
        this.setState({
            form: FORM_KEYS.reduce((acc, key) => { acc[key] = this.props.data[key]; return acc; }, {})
        })
    }

    onInputChange = e => {
        const { target: { name, value } } = e
        this.setState(state => ({
            form: {
                ...state.form,
                [name]: value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }

    onClose = () => {
        this.setState(this.getInitState());
        this.props.onHide();
    }

    onSubmit = e => {
        e.preventDefault();
        if (!this.validateForm()) return
        const { form } = this.state;
        let data={ ...form };
        this.props.updateFranchise(data)
    }

    validateForm = () => {
        const { form } = this.state
        const errors = {}

        Object.keys(form).map(key => {
            if (!form[key]) errors[key] = 'Required';
        })
      if (!validatePhone(form.phoneNumber)) errors.phoneNumber = 'Invalid Phone';

        this.setState({ errors });

        return isEmpty(errors)
    }


    render() {
        const { show } = this.props;
        const { form, errors } = this.state;

        return (
            <Modal
                show={show}
                onHide={this.onClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Edit Franchise Owner
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.name})}>Name</label>
                            <input
                                name="name"
                                type="text"
                                className={classNames('form-control', { 'is-invalid': errors.name })} 
                                value={form.name}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.name}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className={classNames({'text-danger': errors.phoneNumber})}>Phone Number</label>
                            <input
                                name="phoneNumber"
                                type="number"
                                className={classNames('form-control', { 'is-invalid': errors.phoneNumber })} 
                                value={form.phoneNumber}
                                onChange={this.onInputChange}
                            />
                            <ErrorText error={errors.phoneNumber}/>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger" onClick={this.onClose}>Close</button>
                <button className="btn btn-primary" onClick={this.onSubmit}>Save</button>
            </Modal.Footer>
        </Modal>
        )
    }
}